import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      duration={6000}
      style={{
        '--width': '420px',
      }}
      toastOptions={{
        style: {
          padding: '20px 24px',
          fontSize: '16px',
          minWidth: '380px',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-xl group-[.toaster]:border-2",
          title: "group-[.toast]:text-lg group-[.toast]:font-bold",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-base group-[.toast]:mt-1",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toaster]:border-green-500 group-[.toaster]:bg-green-50 dark:group-[.toaster]:bg-green-950/50",
          error: "group-[.toaster]:border-red-500 group-[.toaster]:bg-red-50 dark:group-[.toaster]:bg-red-950/50",
          warning: "group-[.toaster]:border-yellow-500 group-[.toaster]:bg-yellow-50 dark:group-[.toaster]:bg-yellow-950/50",
          info: "group-[.toaster]:border-blue-500 group-[.toaster]:bg-blue-50 dark:group-[.toaster]:bg-blue-950/50",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
